import React from 'react';
import { Card } from '@/components/ui/card';
import { Calendar } from 'lucide-react';
import { getSportColor } from '../../../lib/utils';
import DateTimeDisplay from '../../../components/booking/DateTimeDisplay';

/** Top card on the Payment page: booking date/time + assigned-court chips. */
export default function BookingSummaryCard({ booking }) {
  return (
    <Card className="p-4 bba-card bba-card-accent">
      <div className="space-y-3">
        <div className="flex items-start gap-2">
          <Calendar className="w-5 h-5 text-muted-foreground mt-1" />
          <DateTimeDisplay
            date={booking.booking_date}
            timeSlot={booking.time_slot}
            duration={booking.duration || 1}
            testId="payment-page"
          />
        </div>
        {booking.duration > 1 && (
          <span className="inline-block px-2 py-0.5 bg-primary/10 text-primary rounded-full text-xs font-bold">
            {booking.duration} hours
          </span>
        )}
        <div className="flex gap-2 mt-2">
          {booking.courts_assigned?.map((court, idx) => (
            <span key={idx} className={`sport-badge ${getSportColor(court.sport)}`}>
              Court {court.court_number} - {court.sport}
            </span>
          ))}
        </div>
      </div>
    </Card>
  );
}
